import "./Section.scss";

const Section = ({ children, className, id, title }) => {
  return (
    <section className={className} id={id}>
      {title && <h1 className="title_page">{title}</h1>}
      {children}
    </section>
  );
};

export default Section;
